// document.addEventListener("DOMContentLoaded", () => {
//   const faqCollpsible = document.querySelectorAll(".Collapsible__Button");

//   faqCollpsible.forEach((collapsButton) => {
//     collapsButton.addEventListener("click", (event) => {
//       event.preventDefault()
//       event.stopPropagation()

//       faqCollpsible.forEach((collap) => {
//         close(collap);
//       });

//       const isExpanded = collapsButton.getAttribute("aria-expanded") === "true";
//       collapsButton.setAttribute("aria-expanded", !isExpanded);
//       openCollapsible(collapsButton, isExpanded);
//     });
//   });
// });

// function openCollapsible(button, isClosed = true) {
//   const content = button.parentElement.querySelector('.Collapsible__Inner');
//   content.style.height = isClosed ? '0px' : 'auto';
//   button.parentElement.style.overflow = isClosed ? "hidden" : "visible";
// }

// function closeCollapsible(button) {
//   openCollapsible(button, true);
// }

document.addEventListener("DOMContentLoaded", () => {
  const faqCollapsible = document.querySelectorAll(".Collapsible__Button");

  faqCollapsible.forEach((collapsButton) => {
    collapsButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      faqCollapsible.forEach((collap) => {
        closeCollapsible(collap);
      });

      const isExpanded = collapsButton.getAttribute("aria-expanded") === "true";
      collapsButton.setAttribute("aria-expanded", !isExpanded);
      openCollapsible(collapsButton, !isExpanded);
    });
  });
});

function openCollapsible(button, isOpen) {
  const content = button.parentElement.querySelector('.Collapsible__Inner');
  if (isOpen) {
    content.style.height = content.scrollHeight + 'px';
    button.parentElement.style.overflow = "visible";
  } else {
    content.style.height = '0px';
    button.parentElement.style.overflow = "hidden";
  }
}

function closeCollapsible(button) {
  openCollapsible(button, false);
}

